module.exports = __webpack_public_path__ + "img/wyht.93911ec8.svg";